import styled from "styled-components";
import { pxToRem } from "../../styles/utils";

export const RegistrationWrapper = styled.div`
  margin: 0 auto;
  max-width: ${pxToRem(400)};
  padding: ${pxToRem(20)};
  border-radius: ${({ theme }) => pxToRem(theme.radii.md)};
  background-color: ${({ theme }) => theme.colors.whiteHex};
  box-shadow: ${({ theme }) => theme.shadows.md};
`;

export const VerificationHint = styled.p`
  width: 100%;
  max-width: ${pxToRem(369)};
  margin: ${({ theme }) => pxToRem(-theme.spacing.sm)} auto ${({ theme }) => pxToRem(theme.spacing.lg)};
  color: ${({ theme }) => theme.colors.inkMuted};
  font-size: ${({ theme }) => pxToRem(theme.fontSize.sm)};
  line-height: 1.45;
  text-align: left;

  strong {
    color: ${({ theme }) => theme.colors.ink};
    font-weight: 500;
  }
`;

export const ConsentSection = styled.div`
  width: 100%;
  max-width: ${pxToRem(369)};
  margin: 0 auto ${({ theme }) => pxToRem(theme.spacing.lg)};
`;

export const ConsentIntro = styled.p`
  margin: 0 0 ${({ theme }) => pxToRem(theme.spacing.sm)};
  color: ${({ theme }) => theme.colors.inkMuted};
  font-size: ${({ theme }) => pxToRem(theme.fontSize.sm)};
  line-height: 1.45;
  text-align: left;
`;

export const ConsentList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => pxToRem(theme.spacing.sm)};
`;

export const ConsentRow = styled.label`
  display: flex;
  align-items: flex-start;
  gap: ${pxToRem(10)};
  color: ${({ theme }) => theme.colors.ink};
  cursor: pointer;
  font-size: ${({ theme }) => pxToRem(theme.fontSize.sm)};
  line-height: 1.4;
  text-align: left;
`;

export const ConsentCheckbox = styled.input`
  appearance: none;
  display: grid;
  place-content: center;
  flex: 0 0 auto;
  width: ${pxToRem(20)};
  height: ${pxToRem(20)};
  margin: ${pxToRem(1)} 0 0;
  border: ${pxToRem(1.25)} solid ${({ theme }) => theme.colors.inkBorder};
  border-radius: ${({ theme }) => pxToRem(theme.radii.sm)};
  outline: none;
  background: ${({ theme }) => theme.colors.white};
  cursor: pointer;
  transition: border-color 0.15s ease, background-color 0.15s ease, box-shadow 0.15s ease;

  &::before {
    content: "";
    width: ${pxToRem(11)};
    height: ${pxToRem(11)};
    clip-path: polygon(14% 44%, 0 60%, 40% 100%, 100% 22%, 84% 8%, 38% 68%);
    background: ${({ theme }) => theme.colors.white};
    transform: scale(0);
    transition: transform 0.1s ease;
  }

  &:checked {
    border-color: ${({ theme }) => theme.colors.brand};
    background: ${({ theme }) => theme.colors.brand};
  }

  &:checked::before {
    transform: scale(1);
  }

  &:focus-visible {
    border-color: ${({ theme }) => theme.colors.brand};
    box-shadow: 0 0 0 ${pxToRem(2)} ${({ theme }) => theme.colors.brandSoft};
  }
`;

export const ConsentCopy = styled.span`
  min-width: 0;
`;

export const ConsentLink = styled.a`
  color: ${({ theme }) => theme.colors.brand};
  font-weight: 500;
  text-decoration: underline;
  text-decoration-thickness: ${pxToRem(1)};
  text-underline-offset: ${pxToRem(2)};

  &:hover {
    text-decoration-thickness: ${pxToRem(2)};
  }

  &:focus-visible {
    outline: ${pxToRem(2)} solid ${({ theme }) => theme.colors.brand};
    outline-offset: ${pxToRem(2)};
    border-radius: ${pxToRem(2)};
  }
`;

export const ConsentStatus = styled.p<{ $error?: boolean }>`
  margin: 0;
  color: ${({ theme, $error }) => ($error ? theme.colors.dangerText : theme.colors.inkMuted)};
  font-size: ${({ theme }) => pxToRem(theme.fontSize.sm)};
  line-height: 1.45;
  text-align: left;
`;
